import * as Highcharts from 'highcharts';
import * as numeral from 'numeral';
import * as _ from 'underscore';

import { Component, Input, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS, R7_CHARTS_TOOLTIPS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';

@Component({
	selector: 'app-ctv-daypart-r7',
	styleUrls: ['./ctv-daypart-r7.component.css'],
	templateUrl: './ctv-daypart-r7.component.html'
})
export class CtvDaypartR7Component implements OnInit {
	@Input() sectiontitle: string;
	@Input() colorsconfig: any;
	@Input() chartconfiguration: any;
	@Input() sectionclass: any;
	public reloadSubscription;
	public widgetDataSubscription;
	public key: string;
	public chartConfig: any;
	public colorPalette: ColorPalette;
	public showLoad = false;
	public hasData: boolean = true;
	public categories: any = [];
	public seriesData: any;
	public daypartChartObjArray: any[] = [];
	chartObj: any;
	public timezone: string = '';

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.chartConfig = JSON.parse(decodeURI(this.chartconfiguration));
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;

		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}
	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService
			.processCustomServiceRequest(this.key)
			.subscribe((response: any) => {
				this.showLoad = false;
				this.timezone = response && response.timezone ? `(${response.timezone})` : '';
				if (response.success && response.data.length > 0) {
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
			});
	}
	processResponseData(responseData: any): void {
		this.daypartChartObjArray = this.buildDayPartChartCollatorByFields(responseData);
		this.daypartChartObjArray[0].chartObj.map((data, index) => {
			if (data.dayparttime) {
				data.color = this.getColorFromColorConfig(1, 1);
			}
		});

		this.generateGraph();
	}
	getColorFromColorConfig(index: number, opacity?: number): string {
		const colorConfig: ColorConfig = this.colorsconfig[index];

		const fillOpacity = colorConfig ? colorConfig.opacity : opacity;
		let rgb = '';
		if (colorConfig && colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else if (colorConfig && colorConfig.color) {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}
	buildDayPartChartCollatorByFields(daypartResponseData: any): any[] {
		this.categories = [];
		const fieldChartArray: any[] = [];
		const chartObjArray: any[] = [];
		const daypartData: any = {};
		for (let index = 0; index < daypartResponseData.length; index++) {
			const chartObj: any = {};
			chartObj.name = daypartResponseData[index].daypart;
			chartObj.dayparttime = daypartResponseData[index].friendly_name;
			chartObj.y = Number(daypartResponseData[index].impressions);
			chartObj.displayOrder = daypartResponseData[index].display_order || index;
			chartObjArray.push(chartObj);
			this.categories.push(chartObj.name);
		}
		daypartData.chartObj = _.sortBy(chartObjArray, 'displayOrder');
		fieldChartArray.push(daypartData);
		return fieldChartArray;
	}

	generateGraph(): void {
		this.categories = this.daypartChartObjArray[0].chartObj.map((el) => {
			return `<b>${el.name}</b><br/>${el.dayparttime}`;
		});
		this.chartObj = Highcharts.chart('chartElement', {
			chart: {},
			credits: {
				enabled: false
			},
			legend: {
				align: this.chartConfig.graphConfig.legendConfig.align,
				itemHoverStyle: {
					color: this.chartConfig.graphConfig.legendConfig.itemHoverStyle.color,
					fontWeight: this.chartConfig.graphConfig.legendConfig.itemHoverStyle.fontWeight
				},
				itemMarginBottom: 30,
				itemStyle: {
					color: this.chartConfig.graphConfig.legendConfig.itemStyle.color,
					fontWeight: this.chartConfig.graphConfig.legendConfig.itemStyle.fontWeight
				},
				symbolRadius: 2,
				verticalAlign: this.chartConfig.graphConfig.legendConfig.verticalAlign
			},
			plotOptions: {
				column: {
					borderRadius: 5,
					borderWidth: 0
				},
				series: {
					events: {
						legendItemClick: (): boolean => {
							return false;
						}
					}
				}
			},
			series: [
				{
					color: this.getColorFromColorConfig(1, 1),
					data: this.daypartChartObjArray[0].chartObj,
					dataLabels: {
						enabled: false
					},
					name: 'Impressions',
					showInLegend: true,
					states: {
						hover: {
							enabled: false
						}
					},
					type: this.chartConfig.seriesConfig[0].type
				}
			],
			title: {
				text: null
			},
			tooltip: {
				...R7_CHARTS_TOOLTIPS,
				// tslint:disable-next-line: object-literal-shorthand
				formatter: function (): string {
					return `<div style="font-weight: 600;color: #343434;font-size: 12px;">${numeral(this.y).format('0,0')}</div>`;
				}
			},
			xAxis: {
				categories: this.categories,
				crosshair: false,
				labels: {
					style: {
						lineHeight: 20
					},
					y: 25
				},
				tickWidth: 2,
				tickmarkPlacement: 'on'
			},
			yAxis: {
				labels: {
					enabled: false
				},
				min: 0,
				title: {
					text: null
				},
				visible: false
			}
		});
	}
}
